import { ref, onMounted, onBeforeUnmount } from "vue";

/**
 * Reactive media query.
 *
 * Used where a breakpoint has to change the DOM rather than just its CSS —
 * the ledger drops its summary and category cells below 720px with v-if, so
 * nothing is laid out invisibly on a phone.
 */
export function useMediaQuery(query) {
  const matches = ref(false);
  let mql = null;
  const update = (e) => {
    matches.value = e.matches;
  };

  onMounted(() => {
    mql = window.matchMedia(query);
    matches.value = mql.matches;
    mql.addEventListener("change", update);
  });

  onBeforeUnmount(() => {
    if (mql) mql.removeEventListener("change", update);
  });

  return matches;
}

export const useIsNarrow = () => useMediaQuery("(max-width: 720px)");
